(ns shared.core.amelia-light.components.waffle-menu
  (:require [clojure.string :as s]
            [shared.core.amelia-light.components.icon :as alc-icon]
            [shared.core.reactive :as re]
            ["@up/base-ui/components/ui/badge" :refer [Badge]]
            ["@up/base-ui/components/ui/button" :refer [buttonVariants]]
            ["@up/base-ui/components/ui/command" :refer [Command CommandGroup CommandItem CommandList]]
            ["@up/base-ui/components/ui/popover" :refer [Popover PopoverContent PopoverTrigger]]
            ["@up/base-ui/icons/common/DoneIcon" :default DoneIcon]
            ["@up/base-ui/icons/common/TilesMenuIcon" :default TilesMenuIcon]))

(defn- trigger-class [open?]
  (buttonVariants #js {:variant (if open? "togglePressed" "ghost") :icon "md"}))

(defn- default-is-active-item [item-url current]
  (boolean (and current item-url (s/starts-with? current item-url))))

(defn- section-heading [{:keys [title labels]}]
  (when title
    [:div {:class-name "flex w-full justify-between text-xs"}
     [:span {:class-name "text-up-text-secondary uppercase"} title]
     (for [label labels]
       ^{:key label}
       [:> Badge {:variant "secondary"
                  :class-name "rounded-full px-2 py-0 ps-1.5 pe-1.5 text-xs"}
        label])]))

(defn up-waffle-menu [_]
  (let [open?* (re/ratom false)]
    (fn [{:keys [menu-sections active-item is-active-item icon-component]}]
      (let [is-active? (or is-active-item default-is-active-item)
            Icon (or icon-component TilesMenuIcon)
            section-count (count menu-sections)]
        [:> Popover {:open @open?* :on-open-change #(reset! open?* %)}
         [:> PopoverTrigger {:as-child true}
          [:button {:type "button"
                    :class-name (trigger-class @open?*)}
           [:> Icon]
           [:span {:class-name "sr-only"} "Open menu"]]]
         [:> PopoverContent {:class-name "w-auto p-0" :align "start"}
          [:> Command
           [:> CommandList {:class-name "max-h-full"}
            (doall
              (map-indexed
                (fn [idx {:keys [title items] :as section}]
                  ^{:key (or title idx)}
                  [:> CommandGroup {:heading (re/as-element [section-heading section])
                                    :class-name (cond-> "space-y-2"
                                                        (< idx (dec section-count))
                                                        (str " mb-2"))}
                   (for [{:keys [title url icon-type]} items
                         :let [active? (is-active? url active-item)
                               item-icon (get alc-icon/up-icons icon-type)]]
                     ^{:key title}
                     [:> CommandItem {:value title
                                      :class-name (when active? "bg-up-background-active")
                                      :as-child true}
                      [:a (cond-> {:href url
                                   :class-name "flex w-full"
                                   :on-click #(reset! open?* false)}
                                  active? (assoc :aria-current "page"))
                       (when item-icon
                         [:> item-icon {:class-name "size-5 text-up-icons-primary"
                                        :aria-hidden true}])
                       title
                       (when active?
                         [:<>
                          [:span {:class-name "sr-only"} "Current page"]
                          [:span {:class-name "ml-auto"}
                           [:> DoneIcon]]])]])])
                menu-sections))]]]]))))
